import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Mot de passe simple pour l'admin (tu pourras le changer)
    const ADMIN_PASSWORD = 'AmsWeb2025!';
    
    if (password === ADMIN_PASSWORD) {
      // Stocker le token dans sessionStorage
      sessionStorage.setItem('adminAuth', 'true');
      navigate('/admin/articles');
    } else {
      setError('Mot de passe incorrect');
    }
  };

  return (
    <div className="app">
      <div className="admin-login-container">
        <div className="admin-login-box">
          <h1>🔒 Admin AmsWeb</h1>
          <p>Accès réservé à l'administrateur</p>
          
          <form onSubmit={handleLogin} className="admin-login-form">
            <input
              type="password"
              placeholder="Mot de passe admin"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="admin-input"
              autoFocus
            />
            
            {error && <div className="admin-error">{error}</div>}
            
            <button type="submit" className="btn btn-primary btn-large">
              Se connecter
            </button>
          </form>
          
          <button onClick={() => navigate('/')} className="btn btn-secondary" style={{marginTop: '1rem'}}>
            Retour au site
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
